// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../../assets/stylesheets/variables.scss\"","midnightColor":"#201C1C","content":"AddTextCombination_content__cYspN"};